module.exports = __webpack_public_path__ + "img/w3_chevron_up_red.ed8e6754.png";